import { Reducer } from 'react';
import { CustomerAddress } from 'models/CustomerAddress';
import * as rules from 'components/Input/validation';

export type OwnProps = {
  address?: CustomerAddress;
  email?: string;
  onChange: (address: CustomerAddress, email: string) => void;
  changeMode: boolean;
  toggleChange: (value?: unknown) => void;
  validationError: () => void;
};

interface InputState {
  value: string;
  error: string | undefined;
}

interface OwnState {
  name: InputState;
  street: InputState;
  zipCode: InputState;
  city: InputState;
  phone: InputState;
  email: InputState;
  streetSuggestionsVisible: boolean;
}

export type DisplayAddressProps = {
  state: OwnState;
  toggle: () => void;
};

export type ChangeAddressProps = {
  state: OwnState;
  toggle: () => void;
  dispatch: (value: Action) => void;
  reset: () => void;
  onChange: (address: CustomerAddress, email: string) => void;
  validationError: () => void;
};

export const initialState: OwnState = {
  name: { value: '', error: '' },
  street: { value: '', error: '' },
  zipCode: { value: '', error: '' },
  city: { value: '', error: '' },
  phone: { value: '', error: '' },
  email: { value: '', error: '' },
  streetSuggestionsVisible: false
};

export type Action =
  | { type: 'name'; value: InputState }
  | { type: 'street'; value: InputState }
  | { type: 'zipCode'; value: InputState }
  | { type: 'city'; value: InputState }
  | { type: 'phone'; value: InputState }
  | { type: 'email'; value: InputState }
  | { type: 'streetSuggestionsVisible'; value: boolean };

export const ownReducer: Reducer<OwnState, Action> = (state, action) => {
  switch (action.type) {
    case 'name':
      return { ...state, name: action.value };
    case 'street':
      return { ...state, street: action.value };
    case 'zipCode':
      return { ...state, zipCode: action.value };
    case 'city':
      return { ...state, city: action.value };
    case 'phone':
      return { ...state, phone: action.value };
    case 'email':
      return { ...state, email: action.value };
    case 'streetSuggestionsVisible':
      return { ...state, streetSuggestionsVisible: action.value };
    default:
      return state;
  }
};

export type InputType = 'name' | 'street' | 'zipCode' | 'city' | 'phone' | 'email';

export const validate = (state: OwnState, dispatch: (value: Action) => void) => {
  let isValid = true;

  if (rules.name(state.name.value)) {
    dispatch({
      type: 'name',
      value: {
        value: state.name.value,
        error: rules.name(state.name.value)
      }
    });
    isValid = false;
  }

  if (rules.street(state.street.value)) {
    dispatch({
      type: 'street',
      value: {
        value: state.street.value,
        error: rules.street(state.street.value)
      }
    });
    isValid = false;
  }

  if (rules.zipCode(state.zipCode.value)) {
    dispatch({
      type: 'zipCode',
      value: {
        value: state.zipCode.value,
        error: rules.zipCode(state.zipCode.value)
      }
    });
    isValid = false;
  }

  if (rules.city(state.city.value)) {
    dispatch({
      type: 'city',
      value: {
        value: state.city.value,
        error: rules.city(state.city.value)
      }
    });
    isValid = false;
  }

  if (rules.phone(state.phone.value)) {
    dispatch({
      type: 'phone',
      value: {
        value: state.phone.value,
        error: rules.phone(state.phone.value)
      }
    });
    isValid = false;
  }

  if (rules.email(state.email.value)) {
    dispatch({
      type: 'email',
      value: {
        value: state.email.value,
        error: rules.email(state.email.value)
      }
    });
    isValid = false;
  }

  return isValid;
};
